import { IDataProvider } from "@/store";
import DocumentTemplate from "@/types/documents/documentTemplate/DocumentTemplate";

export interface IDocumentTemplateState {
  documentTemplate: DocumentTemplate | null;
  documentTemplates: DocumentTemplate[] | null;
  dataProvider: IDataProvider<DocumentTemplate>;
}

export const state: IDocumentTemplateState = {
  documentTemplate: null,
  documentTemplates: null,
  dataProvider: {
    items: [],
    pager: {
      buttonsToShow: 3,
      currentPage: 1,
      endPage: 1,
      startPage: 1,
      totalPages: 1,
    },
  },
};
